/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeenglishsyllablebuilder4Inputs */

const zh_learn_mistakestypeenglishsyllablebuilder4 = /** @type {(inputs: Learn_Mistakestypeenglishsyllablebuilder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节拼写`)
};

const en_learn_mistakestypeenglishsyllablebuilder4 = /** @type {(inputs: Learn_Mistakestypeenglishsyllablebuilder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllable Builder`)
};

const es_learn_mistakestypeenglishsyllablebuilder4 = /** @type {(inputs: Learn_Mistakestypeenglishsyllablebuilder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructor de sílabas`)
};

/**
* | output |
* | --- |
* | "Syllable Builder" |
*
* @param {Learn_Mistakestypeenglishsyllablebuilder4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeenglishsyllablebuilder4 = /** @type {((inputs?: Learn_Mistakestypeenglishsyllablebuilder4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeenglishsyllablebuilder4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeenglishsyllablebuilder4(inputs)
	if (locale === "en") return en_learn_mistakestypeenglishsyllablebuilder4(inputs)
	return es_learn_mistakestypeenglishsyllablebuilder4(inputs)
});
export { learn_mistakestypeenglishsyllablebuilder4 as "learn_mistakesTypeEnglishSyllableBuilder" }